import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Switch as ChakraSwitch,
} from "@chakra-ui/react";
import { useField } from "formik";
import type { ChangeEvent, FC } from "react";
import { useMemo, useCallback } from "react";
import type { SwitchFieldProps } from "./types";

export * from "./types";

export const SwitchField: FC<SwitchFieldProps> = (props) => {
  const {
    name,
    label,
    labelProps,
    inline = true,
    isDisabled = false,
    alignItems = "center",
    onChange,
    customOnChange,
  } = props;

  const [field, meta, helpers] = useField(name);

  const hasError = useMemo(() => {
    return !!meta.touched && !!meta.error;
  }, [meta.error, meta.touched]);

  const onChangeHandler = useCallback(
    (e: ChangeEvent) => {
      helpers.setValue(!field.value);
      onChange?.(e as any);
      customOnChange?.(!field.value);
    },
    [customOnChange, field.value, helpers, onChange]
  );

  return (
    <FormControl
      isInvalid={hasError}
      display="flex"
      flexDirection={inline ? "row" : "column"}
      alignItems={alignItems}
    >
      {!!label && <FormLabel {...labelProps}>{label}</FormLabel>}

      <ChakraSwitch
        id={name}
        {...field}
        onChange={(e) => {
          onChangeHandler(e);
        }}
        isChecked={field.value}
        isDisabled={isDisabled}
      />
      {hasError && <FormErrorMessage>{meta.error}</FormErrorMessage>}
    </FormControl>
  );
};
